import React, { useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import {
    Calendar as BigCalendar,
    Views,
    DateLocalizer,
    momentLocalizer,
} from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Novelties.css'
import { ScrollPanel } from 'primereact/scrollpanel';
import { TreeTable } from 'primereact/treetable';
import { Carousel } from 'primereact/carousel';
import Maps from '../Maps/Maps'
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import Maps2 from '../Maps/Maps2';
import Webcam from 'react-webcam';
import { Image } from 'primereact/image';
import fileToBase64 from '../../services/fileToBase64';
import { FileUpload } from 'primereact/fileupload';
import { useLocation } from '../Maps/LocationContext';
import Places from '../Maps/Places';
import { Checkbox } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';
import { Message } from 'primereact/message';
import { MultiSelect } from 'primereact/multiselect';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import { saveAs } from 'file-saver';
import axios from 'axios';


const Novelties = () => {

    const [fechaInicio, setFechaInicio] = useState("")
    const [fechaInicioNov, setFechaInicioNov] = useState(new Date(Date.now()))
    const [hora, setHora] = useState(new Date(Date.now()))
    const [fechaInicioCalendario, setFechaInicioCalendario] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])
    const [novedades, setNovedades] = useState([])
    const { width, height } = useWindowDimensions()

    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [consultado, setConsultado] = useState(0)
    const [loadPage, setLoadPage] = useState(false)
    const [contract, setContract] = useState("")

    const toast = useRef(null);
    const elementWidth = { width: "20rem" }
    const headers = {
        authorization: localStorage.getItem('token')
    }

    let sixDate = new Date(Date.now())
    sixDate.setMonth(sixDate.getMonth() - 12)
    let initDate = new Date('2022-07-13')

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [registros, setRegistros] = useState([]);

    const [idSolicitud, setIdSolicitud] = useState("")
    const [tipo, setTipo] = useState("")
    const [consolidado, setConsolidado] = useState("")
    const [diasTiempo, setDiasTiempo] = useState("")
    const [diasDinero, setDiasDinero] = useState("")
    const [fechaFin, setFechaFin] = useState("")
    const [files, setFiles] = useState([])
    const [inChecked, setInChecked] = useState(false)
    const [outChecked, setOutChecked] = useState(false)

    const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
    const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
    const [contingencia, setContingencia] = useState("")
    const [tiempo, setTiempo] = useState("")
    const [observaciones, setObservaciones] = useState("")
    const [adjunto, setAdjunto] = useState("")

    const [longitud, setLongitud] = useState(0)
    const [latitud, setLatitud] = useState(0)
    const [longMap, setLongMap] = useState(0)
    const [latMap, setLatMap] = useState(0)
    const [trackFotos, setTrackFotos] = useState([])
    const [trackInfo, setTrackInfo] = useState({})
    const [trackDescription, setTrackDescription] = useState("")

    const [listaTipo, setListaTipo] = useState([])
    const [listaTipoC, setListaTipoC] = useState([])
    const [listaContingencia, setListaContingencia] = useState([])

    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading4, setLoading4] = useState(false)

    const [type, setType] = useState([])
    const [selectedRows, setSelectedRows] = useState([])

    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenDelete, setIsOpenDelete] = React.useState(false);

    const [isOpenA, setIsOpenA] = React.useState(false);
    const [isOpenR, setIsOpenR] = React.useState(false);
    const [isOpenT, setIsOpenT] = React.useState(false);
    const [isOpenApprove, setIsOpenApprove] = useState(false)

    const [isOpenOptions, setIsOpenOptions] = React.useState(false);

    const [isOpenD, setIsOpenD] = useState(false)

    const [trackingType, setTrackingType] = useState('')

    const [isOpenMapa, setIsOpenMapa] = useState(false)

    const [captured, setCaptured] = useState(false)
    const [loadCaptured, setLoadCaptured] = useState(false)
    const [tries, setTries] = useState(0)
    const [manual, setManual] = useState(false)

    const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);
    const { location } = useLocation();
    const [ciudad, setCiudad] = useState("")
    const [pais, setPais] = useState("")

    const [dialingData, setDialingData] = useState({
        IMAGE: null,
        IMAGE64: null,
        DATE: '',
        TIME: '',
        PIN: '',
        NAME: '',
        CONTRACT_ID: ''
    });

    const labelStyle = {
        display: "block",
        float: "left",
        marginTop: "5px",
        width: "100%",
        paddingTop: "5px"
    }

    const fileUploadRef = useRef(null);

    const [rows, setRows] = useState([]);
    const [products, setProducts] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [retry, setRetry] = useState(false)

    const [noveltyCauseList, setNoveltyCauseList] = useState([])
    const [noveltyCauseInfo, setNoveltyCauseInfo] = useState("")
    const [causal, setCausal] = useState("")

    const [isOpenCausal, setIsOpenCausal] = useState(false)

    const [clientList, setClientList] = useState(false)
    const [entityList, setEntityList] = useState(false)
    const [client, setClient] = useState("")
    const [entity, setEntity] = useState("")
    const [rowState, setRowState] = useState({});

    const videoConstraints = {
        width: 400,
        height: 250,
        facingMode: "user"
    };

    const containerStyles = {
        display: 'block',
        maxWidth: '200px',
        // maxHeight: '200px',
        width: 'auto',
        height: 'auto'
    };

    const imgStyles = {
        width: '100%',
        height: '100%',
    };

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        getReqLists()
    }, [])

    useEffect(() => {
        handleLocation()
    }, [])

    const showModal = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
        hideModalOptions()
        limpiar();
    };

    const showModalA = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenA(true);
    };

    const hideModalA = () => {
        setIsOpenA(false);
        hideModalOptions()
        limpiar();
    };

    const showModalT = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        console.log(dialingData)
        setHora(new Date(Date.now()))
        setIsOpenT(true);
    };

    const hideModalT = () => {
        setIsOpenT(false);
        hideModalOptions()
        setManual(false)
        setHora(new Date(Date.now()))
        setTrackingType('')
        setDialingData({
            ...dialingData,
            IMAGE: null,
            IMAGE64: null
        })
        setLatitud(0)
        setLongitud(0)
        setInChecked(false)
        setOutChecked(false)
        limpiar();
        console.log(dialingData)
    };

    const showModalOptions = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        console.log(dialingData)
        setIsOpenOptions(true);
    };

    const hideModalOptions = () => {
        setIsOpenOptions(false);
        // limpiar();
    };

    const selectModal = (tipo) => {
        if (tipo.detail_id === 'VAC') {
            showModal();
            hideModalOptions()
        }
        else if (tipo.detail_id === 'ABS') {
            showModalA();
            hideModalOptions()
        }
        else if (tipo.detail_id === 'TRK') {
            console.log(tipo)
            showModalT();
            hideModalOptions()
        }

    }

    const showModalD = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenD(true);
    };

    const hideModalD = () => {
        setIsOpenD(false);
        //limpiar();
    };

    const showModalR = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenR(true);
    };

    const hideModalR = () => {
        setIsOpenR(false);
        limpiar();
    };

    const showModalApprove = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenApprove(true);
    };

    const hideModalApprove = () => {
        setIsOpenApprove(false);
        limpiar();
    };

    const showModalMapa = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenMapa(true);
    };

    const hideModalMapa = () => {
        setIsOpenMapa()
    };

    const showModalCausal = () => {
        // if (!listasCargadas) {
        //   setListas()
        // }
        setIsOpenCausal(true);
    };

    const hideModalCausal = () => {
        setIsOpenCausal(false);
        //limpiar();
    };

    useEffect(() => {
        tableNov(fechaInicioNov)
    }, [])

    async function limpiar() {
        // setConsolidado("");
        setDiasTiempo("");
        setDiasDinero("");
        setFechaInicio("");
        setFechaFin("");
        setFechaInicioAusentismo("");
        setFechaFinAusentismo("");
        setContingencia("");
        setTiempo("");
        setObservaciones("");
        setTipo("")
        setAdjunto("")
        setDialingData({
            ...dialingData,
            DATE: '',
            TIME: '',
            PIN: '',
            NAME: '',
            CONTRACT_ID: ''
        });
        setCaptured(false)
        setLoadCaptured(false)
        setCausal("")
    }

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    function handleLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {
            console.log("Geolocation not supported");
        }
    }

    async function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        setLatMap(latitude);
        setLongMap(longitude);
        setLatitud(latitude);
        setLongitud(longitude);

        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GEO}`;

        try {
            const response = await axios.get(url);
            const results = response.data.results;

            if (results.length > 0) {
                const addressComponents = results[0].address_components;
                const countryComponent = addressComponents.find(component =>
                    component.types.includes('country')
                );
                const cityComponent = addressComponents.find(component =>
                    component.types.includes('locality')
                );
                console.log(countryComponent)
                console.log(cityComponent)
                if (countryComponent) {
                    setPais(countryComponent.long_name);
                }
                if (cityComponent) {
                    setCiudad(cityComponent.long_name)
                }
            }
        } catch (error) {
            console.error('Error fetching the country name:', error);
        }
        console.log(position)
    }

    function error() {
        console.log("No se puede obtener la localizacion");
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} disabled={!filters1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" style={{ width: '6rem' }} value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NOVELTY_DESC': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const tableNov = async (fecha) => {
        setLoadPage(false)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _fechaInicio = dateFormat(fecha)
        const _token = localStorage.getItem('token')

        setType([])

        const payload = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicio,
            TOKEN: _token
        }

        try {
            await apis.getEmployeesNovelties(payload, headers).then(res => {
                let contracts = res.data.CONTRACTS
                let entity_list = []
                let client_list = []
                let states = {}
                contracts.forEach(cont => {
                    console.log(cont)
                    if (cont.children.length > 0) {
                        let conts = []
                        cont.children.forEach(c => {
                            let nov = c
                            let novDesc = c.data.NOVELTY.split("|")
                            nov = {
                                ...nov,
                                data: {
                                    ...nov.data,
                                    NOVELTY_DESC: novDesc[1]
                                }
                            }
                            conts.push(nov)
                        })
                        console.log(conts)
                        cont.children = conts
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === cont.data.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === cont.data.CLIENT)){
                            let newClient = {
                                CODE: cont.data.CLIENT,
                                NAME: cont.data.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: cont.data.CLIENT,
                            NAME: cont.data.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: cont.data.ENTITY,
                            NAME: cont.data.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    cont.data = {
                        ...cont.data,
                        FULL_CONTRACT: cont.data.CONTRACT_ID + ' ' + cont.data.NAME + ' ' + cont.data.JOB_ID + ' ' + cont.data.CLIENT_NAME + ' ' + cont.data.ENTITY_NAME
                    }
                    states = {
                        ...states,
                        [cont.key]: false
                    }
                })
                console.log(contracts)
                getCauseList()
                setRows(contracts)
                setRowState(states)
                setClientList(client_list)
                setEntityList(entity_list)
                setNovedadesCalendario([])
                setSelectedRows(contracts)
                setLoading1(false)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const onSelection = (e) => {
        setSelectedNodeKeys(e.value)
        let keys = Object.keys(e.value)
        console.log(keys)
        let selected = []
        rows.forEach(row => {
            if (row.children.length > 0) {
                row.children.forEach(child => {
                    if (keys.includes(child.key)) {
                        console.log(child.key)
                        selected.push(child)
                    }
                })
            }
        })
        console.log(selected)
        setRegistros(selected)
    }

    const chageDate = (date) => {
        let newDate = dateFormat(date)
        tableNov(newDate)
    }

    const getCauseList = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        try {
            await apis.noveltyCauseList(_entity, _client, headers).then(res => {
                setNoveltyCauseInfo(res.data.OBSERVATION)
                setNoveltyCauseList(res.data.TRK_APD_CAUSAL)
            })
        }
        catch (error) {
            console.log(error)
        }
    }

    const getRequestDetail = async (rowData) => {

        const _entity = rowData.data.ENTITY
        const _client = rowData.data.CLIENT
        const id = rowData.data.REQUESTS_ID

        try {
            await apis.getRequest(_entity, _client, id, headers).then(res => {
                let solicitud = res.data
                let tipo = solicitud.NOVELTY.split("|")
                setTipo(tipo[0])
                if (tipo[0] === "VAC") {
                    setConsolidado(solicitud.DAY_CSO)
                    setDiasDinero(solicitud.DAYS_DIN)
                    setDiasTiempo(solicitud.DAYS_TIE)
                    setFechaInicio(invDateFormat(solicitud.START_DATE))
                    setFechaFin(invDateFormat(solicitud.END_DATE))
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "ABS") {
                    let _contingencia = solicitud.CONTINGENCY.split("|")
                    setFechaInicioAusentismo(invDateFormat(solicitud.START_DATE))
                    setFechaFinAusentismo(invDateFormat(solicitud.END_DATE))
                    setContingencia({ CODE: _contingencia[0], TYPE: _contingencia[0], NAME: _contingencia[1] })
                    setTiempo(solicitud.DAYS)
                    setObservaciones(solicitud.OBSERVATIONS)
                    if (solicitud.FILES && solicitud.FILES.length > 0) {
                        let adjuntos = solicitud.FILES[0]
                        setAdjunto(adjuntos)
                    }
                }
                else if (tipo[0] === "TRK") {
                    console.log(solicitud)
                    let location = solicitud.GEOLOCATION
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE: solicitud.DATE ? solicitud.DATE : "",
                        TIME: solicitud.TIME ? solicitud.TIME : "",
                        TYPE: solicitud.TYPE ? solicitud.TYPE : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID
                    }
                    setLongitud(parseFloat(location.LON))
                    setLatitud(parseFloat(location.LAT))
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos(imagenes)
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
                else if (tipo[0] === "TURN") {
                    let location = solicitud.GEOLOCATION
                    location[0]["LAT"] = parseFloat(location[0]["LAT"])
                    location[0]["LON"] = parseFloat(location[0]["LON"])
                    location[1]["LAT"] = parseFloat(location[1]["LAT"])
                    location[1]["LON"] = parseFloat(location[1]["LON"])
                    let imagenes = {
                        ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
                        DETAIL: solicitud.FILES ? solicitud.FILES : []
                    }
                    let info = {
                        DATE_IN: solicitud.DATE_IN ? solicitud.DATE_IN : "",
                        DATE_OUT: solicitud.DATE_OUT ? solicitud.DATE_OUT : "",
                        TIME_IN: solicitud.TIME_IN ? solicitud.TIME_IN : "",
                        TIME_OUT: solicitud.TIME_OUT ? solicitud.TIME_OUT : "",
                        STATUS: solicitud.STATUS ? solicitud.STATUS : "",
                        NUMBER_ID: solicitud.NUMBER_ID,
                        TURN_HE_ADI: solicitud.TURN_HE_ADI
                    }
                    setLongitud([location[0]['LON'], location[1]['LON']])
                    setLatitud([location[0]['LAT'], location[1]['LAT']])
                    setTrackDescription(solicitud.CONTRACT_ID)
                    setTrackFotos([imagenes, imagenes])
                    setTrackInfo({
                        ...trackInfo,
                        ...info
                    })
                }
            })
            showModalD()
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const changeStatus = async (status) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        let noveltyCause = []
        let novelties = ''
        let msg = status === 'REC' ? 'Rechazada(s)' : 'Aprobada(s)'
        registros.forEach(reg => {
            novelties = novelties + (reg.data.REQUESTS_ID + ",")
            if (reg.data.TURN_HE_ADI && reg.data.TURN_HE_ADI === 'S') {
                noveltyCause.push(reg)
            }
        })
        novelties = novelties.slice(0, -1)

        const requests = {
            ENTITY: _entity,
            CLIENT: _client,
            STATUS: status,
            NOVELTIES: novelties,
            TURN_CAUSAL: causal && causal.detail_id
        }

        if (noveltyCause.length === 0 || registros.length === 1) {
            try {
                await apis.putRequests(requests, headers).then(res => {
                    setLoading2(false)
                    setLoading3(false)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Solicitud(es) " + msg + " exitosamente" });
                    tableNov(fechaInicioNov)
                    setRegistros([])
                    setCausal("")
                    setSelectedNodeKeys(null)
                    hideModalApprove()
                    hideModalR()
                })
            }
            catch (err) {
                setLoading2(false)
                setLoading3(false)
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
        }
        else {
            let newMsg = ""
            noveltyCause.forEach((nov, index) => {
                if (index + 1 < noveltyCause.length) {
                    newMsg += nov.data.REQUESTS_ID + ", "
                }
                else {
                    newMsg += nov.data.REQUESTS_ID
                }
            })
            newMsg = "Para el(los) registro(s) " + newMsg + ": " + noveltyCauseInfo
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: newMsg, sticky: true });
        }
    }

    const postRequestVac = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = contract
        const _diasTiempo = diasTiempo
        const _diasDinero = diasDinero
        const _fechaInicio = dateFormat(fechaInicio)
        const _fechaFin = dateFormat(fechaFin)
        let archivos = []

        if (files.length > 0) {
            let _archivo = files[0]
            let nombre = _archivo.name
            let base64 = ""

            await fileToBase64(_archivo).then(res => {
                base64 = res
            })

            archivos.push({
                name: nombre,
                source: base64
            })
        }

        let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
        console.log(date)
        let newDate = ""
        for (let i = 0; i < date.length; i++) {
            if (date.charCodeAt(i) <= 127) {
                newDate += date.charAt(i);
            }
        }

        const document = {
            "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Usuario": localStorage.getItem('user'),
            "/Aplicacion": "Remuner BPO",
            "/Responsable": "Remuner",
            "/Fecha": newDate
        }

        const vacation = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicio,
            END_DATE: _fechaFin,
            DAYS_TIE: _diasTiempo,
            DAYS_DIN: _diasDinero,
            CONTRACT_ID: _contract,
            NOVELTY: "VAC",
            files: archivos,
            DOCUMENT: document
        }

        try {
            await apis.postRequest(vacation, headers).then(res => {
                setLoading1(false)
                tableNov(fechaInicioNov)
                getReqLists()
                hideModal()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Solicitud de vacación agregada exitosamente' });
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const postRequestAbs = async () => {

        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = contract
        const _tiempo = tiempo
        const _fechaInicioAusentismo = dateFormat(fechaInicioAusentismo)
        const _fechaFinAusentismo = dateFormat(fechaFinAusentismo)
        const _contingencia = contingencia.CODE
        const _observaciones = observaciones
        let archivos = []

        if (files.length > 0) {
            let _archivo = files[0]
            let nombre = _archivo.name
            let base64 = ""

            await fileToBase64(_archivo).then(res => {
                base64 = res
            })

            archivos.push({
                name: nombre,
                source: base64
            })
        }

        let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
        console.log(date)
        let newDate = ""
        for (let i = 0; i < date.length; i++) {
            if (date.charCodeAt(i) <= 127) {
                newDate += date.charAt(i);
            }
        }

        const document = {
            "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Usuario": localStorage.getItem('user'),
            "/Aplicacion": "Remuner BPO",
            "/Responsable": "Remuner",
            "/Fecha": newDate
        }

        const vacation = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicioAusentismo,
            END_DATE: _fechaFinAusentismo,
            DAYS: _tiempo,
            CONTRACT_ID: _contract,
            NOVELTY: "ABS",
            CONTINGENCY: _contingencia,
            OBSERVATIONS: _observaciones,
            files: archivos,
            DOCUMENT: document
        }

        try {
            await apis.postRequest(vacation, headers).then(res => {
                setLoading4(false)
                tableNov(fechaInicioNov)
                getReqLists()
                hideModalA()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Solicitud de ausentismo agregada exitosamente' });
            })
        }
        catch (err) {
            setLoading4(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const getReqListsAdd = async (_entity, _client) => {
        try {
            await apis.getRequestListAdd(_entity, _client, "NULL", "WEB", headers).then(res => {
                let tipos = res.data.TYPE_NOVELTIES
                let contingencias = res.data.CONTINGENCY
                setListaTipo(tipos)
                setListaContingencia(contingencias)

            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const getReqLists = async () => {
        try {
            await getReqListsAdd(localStorage.getItem('entity'), localStorage.getItem('client'))
            await apis.getRequestList(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
                let tipos = res.data.TYPE_NOVELTIES
                setListaTipoC(tipos)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const facialRecognition = async (image) => {
        setRetry(false)
        let newImage = image.split(',')[1]
        const payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            IMAGE: newImage,
            TOKEN: localStorage.getItem('token')
        }

        try {
            await apis.postImageRecognition(payload, headers).then(res => {
                handleLocation()
                let data = res.data
                setDialingData({
                    ...dialingData,
                    IMAGE: image,
                    CONTRACT_ID: data.CONTRACT_ID,
                    NAME: data.NAME,
                    PIN: data.PIN
                })
                setTries(0)
            })
        }
        catch (err) {
            console.log(err)
            if (tries == 3) {
                setTries(0)
            }
            else {
                setTries(tries + 1)
            }
        }
    }

    const getDateTime = (date, time) => {
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate().toString()
        let month = Number(date.getMonth() + 1) > 9 ? Number(date.getMonth() + 1).toString() : '0' + Number(date.getMonth() + 1).toString()
        let dateString = day + '-' + month + '-' + date.getFullYear();
        let hours = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
        let minutes = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
        let seconds = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
        let hourString = hours + ':' + minutes + ':' + seconds;

        return {
            DATE: dateString,
            TIME: hourString
        };
    }

    const postTrackingNovelty = async () => {
        setLoadCaptured(true)
        let dateTime = getDateTime(fechaInicioNov, hora);
        const payload = {
            ...dialingData,
            DATE: dateTime.DATE,
            TIME: dateTime.TIME,
            GEOLOCATION: {
                LAT: location ? location.lat() : latitud,
                LON: location ? location.lng() : longitud
            },
            IMAGE: dialingData.IMAGE ? dialingData.IMAGE.split(',')[1] : "",
            INPUT: trackingType,
            TOKEN: localStorage.getItem('token'),
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            CONTRACT_ID: dialingData.CONTRACT_ID ? dialingData.CONTRACT_ID : contract,
            IMAGE64: dialingData.IMAGE64 ? dialingData.IMAGE64 : "",
            METHOD: 'MAN',
            USERNAME: localStorage.getItem('user').toLowerCase(),
            SOURCE: 'SELF'
        }
        try {
            await apis.postTrackingNovelty(payload, headers).then(res => {
                let dateTime = res.data.DATE.split(" ");
                setDialingData({
                    ...dialingData,
                    DATE: dateTime[0],
                    TIME: dateTime[1],
                })
                setCaptured(true)
                setLoadCaptured(false)
                setManual(false)
                tableNov(fechaInicioNov)
                hideModalT()
                limpiar()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Novedad creada exitosamente' });
            })
        }
        catch (err) {
            setLoadCaptured(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
        }
    }

    const handleChangeFechaFinVac = async (fecha) => {
        setFechaInicio(fecha)
        const _entity = localStorage.getItem('entity')
        const _cliente = localStorage.getItem('client')
        const _contract_id = localStorage.getItem('contract_id')
        const _date_ini = dateFormat(fecha);
        const _day_time = diasTiempo;
        if (_date_ini && _day_time !== "" && _day_time > 0) {
            apis.getVacationEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
                setFechaFin(invDateFormat(res.data.END_DATE))
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })
        }
        else {
            setFechaFin("")
        }
    }

    const handleChangeDiasVac = async (dias) => {
        setDiasTiempo(dias)
        const _entity = localStorage.getItem('entity')
        const _cliente = localStorage.getItem('client')
        const _contract_id = localStorage.getItem('contract_id')
        const _date_ini = dateFormat(fechaInicio);
        const _day_time = dias;
        if (_date_ini && _day_time !== "" && _day_time > 0) {
            apis.getVacationEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
                setFechaFin(invDateFormat(res.data.END_DATE))
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })
        }
        else {
            setFechaFin("")
        }
    }

    const handleChangeFechaFincAbs = async (fecha) => {
        setFechaInicioAusentismo(fecha)
        const _entity = localStorage.getItem('entity')
        const _cliente = localStorage.getItem('client')
        const _contract_id = localStorage.getItem('contract_id')
        const _date_ini = dateFormat(fecha);
        const _day_time = tiempo;
        if (_date_ini && _day_time !== "" && _day_time > 0) {
            apis.getLicenseEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
                setFechaFinAusentismo(invDateFormat(res.data.END_DATE))
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })
        }
        else {
            setFechaFinAusentismo("")
        }
    }

    const handleChangeDiasAbs = async (dias) => {
        setTiempo(dias)
        const _entity = localStorage.getItem('entity')
        const _cliente = localStorage.getItem('client')
        const _contract_id = localStorage.getItem('contract_id')
        const _date_ini = dateFormat(fechaInicioAusentismo);
        const _day_time = dias;
        if (_date_ini && _day_time !== "" && _day_time > 0) {
            apis.getLicenseEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
                setFechaFinAusentismo(invDateFormat(res.data.END_DATE))
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })
        }
        else {
            setFechaFinAusentismo("")
        }
    }

    const leftToolbarTemplate = () => {
        const msg = "Para filtrar la información, seleccione uno o varios tipos de novedades.\n Si lo desea, seleccione una empresa. Esto habilitará los clientes\n pertenecientes a dicha empresa y se podrá realizar el filtro por los 3 campos"
        return (
            <React.Fragment>
                <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                <Calendar id="navigators" value={fechaInicioNov}
                    onChange={(e) => {
                        setFechaInicioNov(e.value);
                        setFechaInicioCalendario(e.value);
                        tableNov(e.value)
                    }}
                    locale="es" dateFormat="dd-mm-yy" view='date' yearRange="1900:2150" showIcon
                    placeholder="Seleccione una fecha" maxDate={new Date(Date.now())}
                />
                &nbsp;
                <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                    data-pr-classname="text-primary" style={{ color: '#00a8ff', fontSize: '1.2rem' }} />
                &nbsp;
                <MultiSelect value={type} options={listaTipoC} onChange={(e) => filterByType(e.value)} optionLabel="description"
                    placeholder="Tipo novedades" style={{ width: '12rem' }} maxSelectedLabels={1} selectedItemsLabel='{0} tipos seleccionados' />
                &nbsp;
                <Dropdown value={entity} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                    placeholder="Empresa" style={{ width: '12rem' }} tooltip={entity?.NAME} tooltipOptions={{position: 'top'}}/>
                &nbsp;
                <Dropdown value={client} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entity}
                    placeholder="Cliente" style={{ width: '12rem' }} tooltip={client?.NAME} tooltipOptions={{position: 'top'}}/>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button disabled={registros.length < 1} label="Aprobar" icon="pi pi-check" className=" mr-2 p-button-sm p-button-success" onClick={showModalApprove} />
                <Button disabled={registros.length < 1} label="Rechazar" icon="pi pi-times" className=" mr-2 p-button-sm p-button-danger" onClick={showModalR} />
            </React.Fragment>
        )
    }

    const applyFilters = (types, entity_, client_) => {
        let filtered = selectedRows.map(row => ({
            ...row,
            children: [...row.children]
        }));
    
        if (entity_) {
            filtered = filtered.filter(row => row.data.ENTITY === entity_.CODE);
        }
    
        if (client_) {
            filtered = filtered.filter(row => row.data.CLIENT === client_.CODE);
        }
    
        if (types && types.length > 0) {
            filtered = filtered
                .map(row => {
                    const children = row.children.filter(child =>
                        types.some(type =>
                            child.data.NOVELTY.split('|')[0] === type.detail_id
                        )
                    );
    
                    if (children.length === 0) return null;
    
                    return {
                        ...row,
                        children
                    };
                })
                .filter(Boolean);
        }
    
        setRows(filtered);
    };

    const filterByType = (types) => {
        setType(types);
        applyFilters(types, entity, client);
    };

    const filterByEntity = (entity_) => {
        setEntity(entity_);
        setClient("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(type, entity_, entity_  ? client : undefined);
    };

    const filterByClient = (client_) => {
        setClient(client_);
        applyFilters(type, entity, client_ ? client_ : undefined);
    };

    const photoBodyTemplate = (rowData) => {
        let photo = rowData.data.IMAGES ? rowData.data.IMAGES : process.env.REACT_APP_PROFILE_PIC
        if (rowData.data.NAME) {
            return (
                <div className='flex flex-row align-items-center justify-content-start gap-1'>
                    <div
                        style={{
                            width: '50px',
                            height: '50px',
                            minWidth: '50px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            flexShrink: 0
                        }}
                    >
                        <img
                            src={photo}
                            alt=""
                            loading="eager"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                    <div className='flex flex-column ml-2'>
                        <span className='font-bold'>{rowData.data.NAME}</span>
                        <span>{rowData.data.CONTRACT_ID} - {rowData.data.JOB_ID}</span>
                        <span><span className='font-bold'>Empresa: </span>{rowData.data.ENTITY_NAME}</span>
                        <span><span className='font-bold'>Cliente: </span>{rowData.data.CLIENT_NAME}</span>
                    </div>
                </div>
            );
        }
    }

    const actionBodyTemplate = (rowData) => {
        if (!rowData.data.NOVELTY) {
            return (
                <div className='flex flex-row justify-content-center'>
                    <Button icon="pi pi-plus" className="p-button-success mr-2 p-button-sm text-xs" tooltip="Crear novedad" tooltipOptions={{ position: 'top' }}
                        loading={rowState[rowData.key]}
                        onClick={async() => {
                            setRowState({ ...rowState, [rowData.key]: true });
                            console.log(rowData.data);
                            setContract(rowData.data.CONTRACT_ID);
                            setConsolidado(rowData.data.DAY_CSO)
                            setDialingData({
                                ...dialingData,
                                PIN: rowData.data.PIN,
                                NAME: rowData.data.NAME,
                                CONTRACT_ID: rowData.data.CONTRACT_ID
                            });
                            console.log(dialingData)
                            try{
                                await getReqListsAdd(rowData.data.ENTITY, rowData.data.CLIENT).then(res => {
                                    setRowState({ ...rowState, [rowData.key]: false });
                                    showModalOptions()
                                })
                            }
                            catch(error){
                                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: error.response.data.message, sticky: true });
                            }
                        }} />
                </div>
            )
        }
        else {
            return (
                <div className='flex flex-row justify-content-center'>
                    <Button icon="pi pi-bars" className="p-button-warning mr-1 p-button-sm text-xs" tooltip="Detalles" tooltipOptions={{ position: 'top' }}
                        onClick={() => { getRequestDetail(rowData) }} />
                    <Button icon="pi pi-check" className="p-button-success mr-1 p-button-sm text-xs" tooltip="Aprobar" tooltipOptions={{ position: 'top' }}
                        onClick={() => {
                            setRegistros([rowData]);
                            if (rowData.data.TURN_HE_ADI && rowData.data.TURN_HE_ADI === 'S') {
                                showModalCausal()
                            }
                            else {
                                showModalApprove()
                            }
                        }}
                    />
                    <Button icon="pi pi-times" className="p-button-danger mr-1 p-button-sm text-xs" tooltip="Rechazar" tooltipOptions={{ position: 'top' }}
                        onClick={() => { setRegistros([rowData]); showModalR() }} />
                </div>
            )
        }
    }

    const itemTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ width: '100%', display: 'block', maxHeight: '40vh' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
    }

    const header = <div className='flex justify-content-center mt-2'>
        <h4>Entrada y salida de la novedad</h4>
    </div>

    const detailHeader = (
        <div>
            <h3>Detalle solicitud</h3>
        </div>
    );

    const footerAprobar = (
        <div>
            <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); changeStatus('APD') }} />
            <Button label="No" onClick={() => hideModalA()} />
        </div>
    );

    const headerAprobar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea aprobar las solicitudes seleccionadas?' : '¿Desea aprobar esta solicitud?'}</h3>
        </div>
    )

    const footerRechazar = (
        <div>
            <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); changeStatus('REC') }} />
            <Button label="No" onClick={() => hideModalR()} />
        </div>
    );

    const headerRechazar = (
        <div>
            <h3>{registros.length > 1 ? '¿Desea rechazar las solicitudes seleccionadas?' : '¿Desea rechazar esta solicitud?'}</h3>
        </div>
    )

    const addFooter = (
        <div>
            <Button onClick={hideModal}>Cancelar</Button>
            <Button onClick={() => { setLoading1(true); postRequestVac() }}
                loading={loading1} label='Guardar'
                disabled={(!diasTiempo && !diasDinero) || !fechaInicio}
            ></Button>
        </div>
    );

    const addHeader = (
        <div>
            <h3>Agregar solicitud vacaciones</h3>
        </div>
    );

    const addFooterA = (
        <div>
            <Button onClick={hideModalA}>Cancelar</Button>
            <Button onClick={() => { setLoading4(true); postRequestAbs() }}
                loading={loading4} label='Guardar'
                disabled={!contingencia || !fechaInicioAusentismo || !fechaFinAusentismo || !tiempo}
            ></Button>
        </div>
    );

    const addHeaderA = (
        <div>
            <h3>Agregar solicitud ausentismo </h3>
        </div>
    );

    const addFooterT = (
        <div>
            <Button onClick={hideModalT} label='Cancelar' />
            <Button label='Aceptar' loading={loadCaptured}
                disabled={!trackingType || !dialingData.CONTRACT_ID || !dialingData.PIN || !fechaInicioNov || !hora}
                onClick={() => { postTrackingNovelty() }} />
        </div>
    );

    const addHeaderT = (
        <div>
            <h3>Agregar novedad</h3>
        </div>
    );

    const optionsHeader = (
        <div>
            <h3>Seleccione tipo de solicitud </h3>
        </div>
    );

    const optionsFooter = (
        <div>
            <Button onClick={hideModalOptions}>Cancelar</Button>
        </div>
    );

    const addFooterCausal = (
        <div>
            <Button onClick={hideModalCausal} label='Cancelar' />
            <Button label='Aceptar' disabled={!causal} onClick={() => { showModalApprove(); hideModalCausal() }} />
        </div>
    );

    const addHeaderCausal = (
        <div>
            <h3>{noveltyCauseInfo}</h3>
        </div>
    );

    const buttonStyle = {
        overflow: "hidden",
        maxWidth: "20rem"
    }

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Novedades</span>
            </div>
            <Dialog header={optionsHeader} footer={optionsFooter} visible={isOpenOptions} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalOptions}>
                <label style={labelStyle} htmlFor="label">Tipo solicitud</label>
                <Dropdown style={elementWidth} value={tipo} autofocus optionLabel='description'
                    filter showClear filterBy="description" emptyMessage={"No hay tipos disponibles"}
                    onChange={(e) => { setTipo(e.value); selectModal(e.value) }} options={listaTipo} placeholder={tipo ? tipo.description : 'Seleccione'} />
            </Dialog>
            <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <label style={labelStyle} htmlFor="label">Dias consolidado</label>
                <InputNumber min={0} value={consolidado} placeholder="Dias tiempo" disabled={true} />
                <label style={labelStyle} htmlFor="label">Dias tiempo</label>
                <InputNumber min={0} value={diasTiempo} onChange={(e) => handleChangeDiasVac(e.value)} placeholder="Dias tiempo" />
                <label style={labelStyle} htmlFor="label">Dias Dinero</label>
                <InputNumber min={0} value={diasDinero} onChange={(e) => setDiasDinero(e.value)} placeholder="Dias Dinero" />
                <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                <Calendar style={elementWidth} id="navigators" value={fechaInicio} onChange={(e) => handleChangeFechaFinVac(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                />
                <label style={labelStyle} htmlFor="label">Fecha fin</label>
                <Calendar style={elementWidth} id="navigators" value={fechaFin} onChange={(e) => { setFechaFin(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" disabled={true} showIcon />
                <label style={labelStyle} htmlFor="label">Adjunto</label>
                <div className='flex flex-wrap align-items-center mt-6 gap-2'>
                    <FileUpload
                        mode="basic" name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                        }}
                        onSelect={(e) => setFiles(e.files)} />
                    <Message severity="info" text="Máx. 2 MB" />
                </div>
            </Dialog>
            <Dialog header={addHeaderA} footer={addFooterA} visible={isOpenA} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalA}>
                <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                <Calendar style={elementWidth} id="navigators" value={fechaInicioAusentismo} onChange={(e) => handleChangeFechaFincAbs(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                />
                <label style={labelStyle} htmlFor="label">Fecha fin</label>
                <Calendar style={elementWidth} id="navigators" value={fechaFinAusentismo} onChange={(e) => setFechaFinAusentismo(e.value)} locale="es"
                    dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                />
                <label style={labelStyle} htmlFor="label">Contingencia</label>
                <Dropdown style={elementWidth} value={contingencia} autofocus optionLabel='NAME'
                    filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                    onChange={(e) => { setContingencia(e.value) }} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
                <label style={labelStyle} htmlFor="label">Tiempo</label>
                <InputNumber min={0} value={tiempo} placeholder="Tiempo" onChange={(e) => handleChangeDiasAbs(e.value)} />
                <label style={labelStyle} htmlFor="label">Observaciones</label>
                <InputTextarea maxLength={70} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} rows={4} cols={30} style={elementWidth} />
                <label style={labelStyle} htmlFor="label">Adjunto</label>
                <div className='flex flex-wrap align-items-center mt-6 gap-2'>
                    <FileUpload
                        mode="basic" name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                        }}
                        onSelect={(e) => setFiles(e.files)} />
                    <Message severity="info" text="Máx. 2 MB" />
                </div>
            </Dialog>

            <Dialog header={addHeaderT} footer={addFooterT} visible={isOpenT} position="top" draggable={false}
                resizable={false} modal onHide={hideModalT} className='modal-trk'>
                <div className='flex flex-row w-full justify-content-center'>
                    <div className="flex align-items-center">
                        <Badge className="ml-2 mr-1" value="Entrada" size="medium" severity="success" />
                        <Checkbox inputId="IN" value="IN" className='check-in'
                            onChange={(e) => {
                                setInChecked(e.checked)
                                if (outChecked) {
                                    setOutChecked(false)
                                }
                                console.log("El valor: ", e.value, e.checked)
                                setTrackingType(e.checked ? e.value : "")
                            }}
                            checked={inChecked}
                        />
                    </div>
                    <div className="flex align-items-center">
                        <Badge className="ml-2 mr-1" value="Salida" size="medium" severity="danger" />
                        <Checkbox inputId="OUT" value="OUT" className='check-out'
                            onChange={(e) => {
                                setOutChecked(e.checked)
                                if (inChecked) {
                                    setInChecked(false)
                                }
                                setTrackingType(e.checked ? e.value : "")
                            }}
                            checked={outChecked}
                        />
                    </div>
                </div>
                &nbsp;
                <div className='flex flex-row w-full justify-content-evenly'>
                    <div className='flex flex-column'>
                        <label>Contrato</label>
                        <InputText value={dialingData.CONTRACT_ID + '-' + dialingData.NAME} disabled />
                    </div>
                    <div className='flex flex-column'>
                        <label>PIN</label>
                        <InputText value={dialingData.PIN} disabled />
                    </div>
                    <div className='flex flex-column'>
                        <label htmlFor="label">Fecha</label>
                        <Calendar id="navigators" value={fechaInicioNov} locale="es" onChange={(e) => setFechaInicioNov(e.value)}
                            dateFormat="dd-mm-yy" yearRange="1900:3000" showIcon
                        />
                    </div>
                    <div className='flex flex-column'>
                        <label htmlFor="label">Hora</label>
                        <Calendar value={hora} onChange={(e) => setHora(e.value)} timeOnly showTime />
                    </div>
                </div>
                &nbsp;
                <div className='flex flex-row w-full justify-content-center'>
                    <div className='flex flex-column align-items-center justify-content-center'>
                        <label>Ubicación</label>
                        <Places lat={latMap} lon={longMap} />
                    </div>
                </div>
            </Dialog>
            <Dialog header={headerAprobar} footer={footerAprobar} visible={isOpenApprove} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalApprove}>
            </Dialog>
            <Dialog header={headerRechazar} footer={footerRechazar} visible={isOpenR} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalR}>
            </Dialog>
            <Dialog header={detailHeader} visible={isOpenD} position="top" style={tipo !== "TRK" ? { width: "26rem" } : { width: "70vw", height: "90vh" }}
                draggable={false} resizable={false} modal onHide={hideModalD}>
                {tipo === "VAC" ? <><label style={labelStyle} htmlFor="label">Dias consolidado</label>
                    <InputNumber min={0} value={consolidado} placeholder="Dias consolidado" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias tiempo</label>
                    <InputNumber min={0} value={diasTiempo} placeholder="Dias tiempo" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Dias Dinero</label>
                    <InputNumber min={0} value={diasDinero} placeholder="Dias Dinero" disabled={true} />
                    <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                    <Calendar id="navigators" value={fechaInicio} locale="es"
                        dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                    />
                    <label style={labelStyle} htmlFor="label">Fecha fin</label>
                    <Calendar id="navigators" value={fechaFin} locale="es" dateFormat="dd-mm-yy"
                        yearRange="2010:2030" disabled={true} showIcon />
                    {adjunto &&
                        <>
                            <label style={labelStyle} htmlFor="label">Adjunto</label>
                            <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                        </>
                    }</>
                    : tipo === "ABS" ?
                        <div className='flex flex-column'>
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaInicioAusentismo} disabled={true} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
                            />
                            <label style={labelStyle} htmlFor="label">Fecha inicio</label>
                            <Calendar id="navigators" value={fechaFinAusentismo} locale="es"
                                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
                            />
                            <label style={labelStyle} htmlFor="label">Contingencia</label>
                            <Dropdown value={contingencia} autofocus optionLabel='NAME'
                                filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                                disabled={true} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
                            <label style={labelStyle} htmlFor="label">Tiempo</label>
                            <InputNumber min={0} value={tiempo} placeholder="Tiempo" disabled={true} />
                            <label style={labelStyle} htmlFor="label">Observaciones</label>
                            <InputTextarea maxLength={70} value={observaciones} disabled={true} rows={4} cols={30} />
                            {adjunto &&
                                <>
                                    <label style={labelStyle} htmlFor="label">Adjunto</label>
                                    <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                                        onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                                </>
                            }
                        </div>
                        : tipo === 'TRK' ?
                            <>
                                <Maps2 latitud={[latitud]} longitud={[longitud]} descripcion={[trackDescription]} icon={[trackFotos]} info={[trackInfo]} />
                                {/* <div className="carousel-demo2">
                                <Carousel value={trackFotos} numVisible={1} numScroll={1} itemTemplate={itemTemplate} header={header} className="custom-carousel" />
                            </div> */}
                            </>
                            :
                            <>
                                <label className='font-bold' style={labelStyle} htmlFor="label">Ingreso:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_IN} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_IN} </span><br />
                                <label className='font-bold' style={labelStyle} htmlFor="label">Salida:</label>
                                <span className='font-bold'>Fecha: </span>
                                <span>{trackInfo.DATE_OUT} </span>
                                <span className='font-bold'>Hora: </span>
                                <span>{trackInfo.TIME_OUT}</span><br />
                                {trackInfo.TURN_HE_ADI && <><span className='font-bold'>Causal: {trackInfo.TURN_HE_ADI === 'S' ? "Si" : "No"}</span><br /></>}
                                <br />
                                <Button label='Ver ubicación' icon='pi pi-eye' size='small' onClick={showModalMapa} /><br /><br />
                                {trackFotos[0] && trackFotos[0].DETAIL && trackFotos[0].DETAIL.length > 0 &&
                                    <div className='card'>
                                        <Galleria value={trackFotos[0].DETAIL} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px' }}
                                            item={itemTemplate} thumbnail={thumbnailTemplate} />
                                    </div>}
                            </>
                }
            </Dialog>
            <Dialog visible={isOpenMapa} draggable={false} resizable={false} modal onHide={hideModalMapa} style={{ width: "70vw", height: "90vh" }}>
                <Maps2 latitud={latitud} longitud={longitud} descripcion={[]} icon={trackFotos} info={[trackInfo]} />
            </Dialog>
            <Dialog header={addHeaderCausal} footer={addFooterCausal} visible={isOpenCausal}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCausal}>
                <Dropdown value={causal} autofocus optionLabel='description' onChange={(e) => setCausal(e.value)} style={{ width: "20rem" }}
                    filter showClear filterBy="description" emptyMessage={"No hay causales disponibles"} tooltip={causal && causal.descripcion}
                    options={noveltyCauseList} placeholder={causal ? causal.description : 'Seleccione'} />
            </Dialog>
            <div className='mt-5 flex justify-content-center flex-column align-items-center'>
                <SkeletonTable load={loadPage}>
                    <Tooltip target=".info" className='indigo-tooltip ml-1' />
                    <Toolbar className='card flex flex-row' start={leftToolbarTemplate} end={rightToolbarTemplate} style={{ width: '80vw' }} />
                    <TreeTable value={rows} selectionMode='checkbox' selectionKeys={selectedNodeKeys} onSelectionChange={onSelection} loading={loading}
                        scrollable scrollHeight="70vh" width="60rem" className="card text-xs" paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        responsiveLayout="scroll">
                        <Column expander style={{ width: '5rem' }}></Column>
                        <Column field="FULL_CONTRACT" body={photoBodyTemplate} filterPlaceholder='Buscar' filter filterMatchMode='contains' style={{ width: '20rem' }} header="Empleados"></Column>
                        {/* <Column field="CONTRACT_ID" header="Contrato" bodyStyle={{ width: '4rem' }} headerStyle={{ width: '4rem' }}></Column>
                        <Column field="NAME" header="Nombre"></Column>
                        <Column field="JOB_ID" header="Cargo"></Column> */}
                        <Column field="NOVELTY_DESC" header="Tipo solicitud" bodyStyle={{ width: '5rem' }} headerStyle={{ width: '5rem' }}></Column>
                        <Column field="START_DATE" header="Feha inicio" bodyStyle={{ width: '5rem' }} headerStyle={{ width: '5rem' }}></Column>
                        <Column field="END_DATE" header="Feha fin" bodyStyle={{ width: '5rem' }} headerStyle={{ width: '5rem' }}></Column>
                        <Column field="TYPE" header="Marcación" bodyStyle={{ width: '5rem' }} headerStyle={{ width: '6rem' }}></Column>
                        <Column header="Acciones" bodyStyle={{ textAlign: 'center', overflow: 'visible', width: '6rem', alignItems: 'center'  }} headerStyle={{ width: '6rem' }} body={actionBodyTemplate} />
                    </TreeTable>
                </SkeletonTable>
            </div>
        </div>
    )

}

export default Novelties